export class PageResumePresenter {
  form_data = {
    title: 'Se ha realizado la transferencia exitosamente',
  };

  transfer_data = {
    title: 'Número de Transacción:',
    operation: '',
  };

  transfer_amount = {
    title: 'Monto Pagado',
    amount: '',
  };
}
